module.exports = __webpack_public_path__ + "media/site/images/products/avisboard-screen@2x-e7c72fab16e9e769cb55f9e186326195.png";